import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import {
  activeProcessSF,
  getActiveProcessKey,
  handleProcess,
  IRydeProcess,
  RydeProcessTitle,
  RydeUiUnit,
  supportsBulkSummaryToast,
  TAddressedFieldsValueOnCompleted,
  useProcesses,
} from "@ryde/shared";

import { useDynamicFormsFetch } from "../use-dynamic-forms-fetch";

export const useWatchBulkBookingCancel = ({
  entity,
  addressedFieldsValueOnCompleted,
}: {
  entity: RydeUiUnit;
  addressedFieldsValueOnCompleted: TAddressedFieldsValueOnCompleted;
}) => {
  const { fetchTableRowsServerFiltered } = useDynamicFormsFetch(
    "booking",
    "bookings",
  );

  const bulkCancelBookingsProcessKey = getActiveProcessKey(
    RydeProcessTitle.BulkCancelBookings,
    entity,
  );

  const bulkCancelBookingsProcess = useRecoilValue(
    activeProcessSF(bulkCancelBookingsProcessKey),
  );
  const { stopProcessPolling } = useProcesses();
  const { t } = useTranslation();

  const onComplete = useCallback(
    (process: IRydeProcess) => {
      fetchTableRowsServerFiltered();
      addressedFieldsValueOnCompleted(process);
    },
    [addressedFieldsValueOnCompleted, fetchTableRowsServerFiltered],
  );

  useEffect(() => {
    handleProcess({
      entity,
      processTitle: RydeProcessTitle.BulkCancelBookings,
      process: bulkCancelBookingsProcess,
      onComplete,
      translationFunction: t,
      stopProcessPolling,
      toastSummaryOnComplete: supportsBulkSummaryToast(entity),
    });
  }, [bulkCancelBookingsProcess, entity, onComplete, stopProcessPolling, t]);
};
